module.exports = __webpack_public_path__ + "assets/img/rainbow.379b4077.png";